import React from 'react';
import AccessDeniedPage from '../../../../authorization/AccessDeniedPage';
import useCanCreateWorkspaceTable from '../../hooks/useCanCreateWorkspaceTable';
import useRecordPermissions from '../../records/hooks/useRecordPermissions';

function CreateFormStudioGuard({ children }) {
  const canCreate = useCanCreateWorkspaceTable();
  return canCreate ? children : <AccessDeniedPage />;
}

function EditFormStudioGuard({ children }) {
  const { canEditForm } = useRecordPermissions();
  return canEditForm ? children : <AccessDeniedPage />;
}

export default function FormStudioAccessGuard({ mode, children }) {
  return mode === 'create' ? (
    <CreateFormStudioGuard>{children}</CreateFormStudioGuard>
  ) : (
    <EditFormStudioGuard>{children}</EditFormStudioGuard>
  );
}
